// extracted by mini-css-extract-plugin
module.exports =  {"container":"container_x5Iec2Os"};